import { Box, Stack, styled } from '@mui/material';

export const VideoCamRecorderCnt = styled(Stack)({
  '& video': {
    borderRadius: 16,
  },

  '& button': {
    borderRadius: 8,
    fontSize: 14,
    fontWeight: 700,
    lineHeight: '24px',
    height: 40,
  },

  '& .stopBtn': {
    backgroundColor: 'rgba(211, 47, 47, 1)',
  },
});

export const InfoBanner = styled(Stack)({
  marginBottom: 20,
  backgroundColor: 'rgba(225, 245, 254, 1)',
  padding: '10px 12px',
  borderRadius: 10,
  '& .icon': {
    height: 18,
    width: 18,
    '& path': {
      color: '#0288D1',
    },
  },
  '& .infoContent': {
    textAlign: 'start',
    fontWeight: 600,
    fontSize: 13,
    lineHeight: '20px',
    color: 'rgba(0, 0, 0, 1)',
  },
});

export const NoCameraAccessCnt = styled(Stack)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',

  '& .emptyCnt': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 600,
    height: 336,
    backgroundColor: 'rgba(38, 50, 56, 1)',
    borderRadius: 16,

    '& .noCameraAccessIcon': {
      width: 40,
      height: 'auto',
    },
  },
});

export const WarningBox = styled(Stack)({
  width: 600,
  height: 81,
  marginTop: 20,
  backgroundColor: 'rgba(255, 235, 238, 1)',
  padding: '12px 16px',
  borderRadius: 10,

  '& svg': {
    color: 'rgba(211, 47, 47, 1)',
  },

  '& .title': {
    fontWeight: 700,
    fontSize: 14,
    lineHeight: '100%',
    letterSpacing: 0,
    marginTop: 4,
    color: 'rgba(198, 40, 40, 1)',
  },
  '& .description': {
    fontWeight: 500,
    fontSize: 13,
    lineHeight: '18px',
    letterSpacing: 0,
    color: 'rgba(198, 40, 40, 1)',
  },
});

export const LoaderCnt = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: 170,
  height: '100%',
  width: '100%',
});
